import { put, takeEvery } from 'redux-saga/effects';
import request from 'utils/request';
import urls from 'utils/config';
import {
  getCourseDetailsSuccess,
  getCourseDetailsFailed,
  clearError,
} from '../actions';
import { CoursesActionTypes } from '../types';
import { networkErrorHandler } from 'utils/errrorHandlers';

const { API_BASE_URL } = urls || {};

export function* fetchCourseDetails({ data }) {
  const { id, callBack } = data;
  const url = `${API_BASE_URL}/courses/${id}`;
  const response = yield request({
    method: 'get',
    url,
  });
  if (response.success) {
    yield put(getCourseDetailsSuccess(response.raw));
    yield put(clearError());
  } else {
    if (callBack && typeof callBack === 'function') {
      callBack();
    }

    networkErrorHandler(response?.statusCode, 'Failed to Fetch Course Details');
    yield put(getCourseDetailsFailed(response.message));
  }
}

export function* getCourseDetails() {
  yield takeEvery(CoursesActionTypes.GET_COURSE_DETAILS, fetchCourseDetails);
}
